module.exports = __webpack_public_path__ + "static/media/Food Processing Entreprise (CMN) - Mobile - 22-11-2024 C.cf9782f4.gif";